import {Button, Stack} from '@mui/material';
import React, {PropsWithChildren} from 'react';

import {ContentState} from 'presentation/components';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {StyledContainer} from './styles';
import {ErrorStateProps} from './types';

const {tryAgain} = translations['pt-br'].commons;

export function ErrorState({
	title,
	description,
	handleRefresh,
	primaryAction,
	primaryText = tryAgain,
	children,
	containerDataTagId,
	buttonDataTagId,
}: PropsWithChildren<ErrorStateProps>) {
	return (
		<StyledContainer data-tag-id={containerDataTagId}>
			<Stack>
				<ContentState
					sx={{p: 4, pb: 2}}
					variant="info"
					title={title}
					description={description}
				/>
				<Button
					onClick={primaryAction || handleRefresh}
					variant={primaryAction ? 'contained' : 'outlined'}
					size="large"
					sx={{alignSelf: 'center'}}
					data-tag-id={buttonDataTagId}
					endIcon={!primaryAction ? <Icon name="reload" /> : null}>
					{primaryText}
				</Button>
				{children}
			</Stack>
		</StyledContainer>
	);
}
